import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import user from './modules/user';
import vehicle from './modules/vehicle';
import history from './modules/history';
import notification from './modules/notification';
import reporting from './modules/reporting';
import geofence from './modules/geofence';
import maintenance from './modules/maintenance';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    vehicle,
    history,
    notification,
    reporting,
    geofence,
    maintenance
  },
  getters
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js